import styled from 'styled-components';
import {Box} from '@sproutsocial/seeds-react-box';
import {Button} from '@sproutsocial/seeds-react-button';
import {PartnerLogo} from '@sproutsocial/seeds-react-partner-logo';
import {Skeleton} from '@sproutsocial/seeds-react-skeleton';
import {pollinateSproutLink} from '../pollination';
import {type TypePageData, type TypeSocialLink} from '../services';

const SocialButton = styled(Button)`
	span {
		display: flex;
		align-items: center;
	}
`;

const NeutralPartnerLogo = styled(PartnerLogo)`
	.logo-svg {
		filter: invert(1);
		@media (max-width: ${props => props.theme.breakpoints[0]}) {
			height: 24px;
			gap: 0;
		}
	}
`;

type TypeSocialLinksProps = {
	page: TypePageData | null | undefined;
};

export default function SocialLinks({page}: TypeSocialLinksProps) {
	if (!page) {
		return (
			<Box display='flex' justifyContent='center' gap={[0, 300]}>
				{Array.from({length: 3}).map((_, index: number) => (
					<Box key={index} p={300} display='flex' justifyContent='center' alignItems='center'>
						<Skeleton width='32px' height='32px' borderRadius='pill' />
					</Box>
				))}
			</Box>
		);
	}

	const {page_id, social_links} = page;

	if (!social_links || social_links.length === 0) return null;

	const pollinateSocialClick = (socialLinkId: string) => {
		pollinateSproutLink({
			feature: 'social_link',
			action: socialLinkId,
			id: page_id,
		});
	};

	return (
		<Box mx={[350, 0]} display='flex' justifyContent='center' flexWrap='wrap' gap={[0, 300]}>
			{social_links.map((social_link: TypeSocialLink, index: number) => {
				const {id, link, social_platform} = social_link;

				return (
					<SocialButton
						key={`${social_platform}-${index}`}
						external
						href={link}
						onClick={() => pollinateSocialClick(id)}
						ariaLabel={social_platform}
					>
						<NeutralPartnerLogo partnerName={social_platform} backgroundType='dark' size='medium' />
					</SocialButton>
				);
			})}
		</Box>
	);
}
